import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import { useAtomValue } from "jotai";

import { isEditingShipmentAtom } from "../../state/shipment-edit-atoms.ts";
import { SPECIAL_INSTRUCTIONS_DEFAULT } from "../../utils/defaults.ts";
import { formatSpecialInstructions } from "../../utils/format-special-instructions.ts";
import { BolNotations } from "./bol-notations.tsx";
import * as styles from "./special-instructions.module.css";
import { SpecialInstructionsEdit } from "./special-instructions-edit.tsx";

type SpecialInstructionsProps = {
	readonly pickupInstructions?: string;
	readonly deliveryInstructions?: string;
	readonly bolNotations?: string;
};

export function SpecialInstructions({
	pickupInstructions,
	deliveryInstructions,
	bolNotations,
}: SpecialInstructionsProps) {
	const isEditing = useAtomValue(isEditingShipmentAtom);

	if (isEditing) {
		return (
			<SpecialInstructionsEdit
				bolNotations={bolNotations}
				deliveryInstructions={deliveryInstructions}
				pickupInstructions={pickupInstructions}
			/>
		);
	}

	const merged = formatSpecialInstructions(
		pickupInstructions,
		deliveryInstructions,
	);
	const pickupDisplay =
		merged.length > 0 ? merged : SPECIAL_INSTRUCTIONS_DEFAULT;

	return (
		<div className={"card-wrapper"}>
			<Card>
				<CardHeader>
					<h3>Special Instructions</h3>
				</CardHeader>
				<CardBody>
					<div className={styles.content}>
						<BolNotations bolNotations={bolNotations} />
						<p
							className={styles.instructions}
							style={{ whiteSpace: "pre-line" }}
						>
							{pickupDisplay}
						</p>
					</div>
				</CardBody>
			</Card>
		</div>
	);
}
